import React from "react";
import PropTypes from "prop-types";
import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIAutoComplete from "@mui/material/Autocomplete";
import MUIGrid from "@mui/material/Grid";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAccountContact extends CardClass {
    constructor(props) {
        super(props);

    }

    static contextType = MainContext; // For legacy class components

    /**
     * Render the content of the card.
     */
    renderContent() {
        const getStateListOptions = () => {
            let stateOptions = [];
            this.context.stateSalesTax.forEach(state => {
                stateOptions.push({
                    label: state.name + " - " + state.abbr,
                    value: state.abbr,
                });
            });
            return stateOptions;
        }

        const handlePhoneNumberChange = (event, fieldName) => {
            const { value } = event.target;
            // Remove all non-digit characters
            const cleaned = value.replace(/\D/g, '');
            // Format the cleaned number
            let formattedNumber = cleaned;
            if (cleaned.length > 3) {
                formattedNumber = `(${cleaned.slice(0, 3)}`;
            }
            if (cleaned.length > 6) {
                formattedNumber += `) ${cleaned.slice(3, 6)}-`;
                formattedNumber += cleaned.slice(6, 10);
            } else if (cleaned.length > 3) {
                formattedNumber += `) ${cleaned.slice(3)}`;
            }
            this.props.onChange({ [fieldName]: formattedNumber ? formattedNumber : null });
        };

        // new fields for contact info: Phone, fax, email. Remove timezone.
        return (
            <MUIGrid container spacing={2}>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.account && this.props.account.addrLine1 ? this.props.account.addrLine1 : ""}
                        size="small"
                        label="Address"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ addrLine1: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ addrLine1: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.addrLine1 ? true : false}
                        helperText={this.props.validationIssues.addrLine1 ? this.props.validationIssues.addrLine1 : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.account && this.props.account.city ? this.props.account.city : ""}
                        size="small"
                        label="City"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ city: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ city: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.city ? true : false}
                        helperText={this.props.validationIssues.city ? this.props.validationIssues.city : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUIAutoComplete
                        options={getStateListOptions()}
                        value={
                            this.props.account
                                ? getStateListOptions().find(option => option.value === this.props.account.state) || null
                                : null
                        }
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        onChange={(e, value) => this.props.onChange({ state: value ? value.value : null })}
                        renderInput={(params) => <MUITextField {...params}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            variant="standard"
                            label="State"
                            required={true}
                            fullWidth
                            error={this.props.validationIssues && this.props.validationIssues.state ? true : false}
                            helperText={this.props.validationIssues ? this.props.validationIssues.state : ""}
                        />}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.account && this.props.account.zip ? this.props.account.zip : ""}
                        size="small"
                        label="Postal Code"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 5,
                            inputMode: "numeric", // Show numeric keyboard
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ zip: e.target.value.trim() })}
                        onChange={(e) => {
                            // Allow only digits
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            this.props.onChange({ zip: value });
                        }}
                        required={true}
                        error={this.props.validationIssues.zip ? true : false}
                        helperText={this.props.validationIssues.zip ? this.props.validationIssues.zip : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.account && this.props.account.phoneNumber ? this.props.account.phoneNumber : ""}
                        size="small"
                        label="Phone"
                        required={true}
                        variant="standard"
                        fullWidth={true}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => handlePhoneNumberChange(e, "phoneNumber")}
                        error={this.props.validationIssues.phoneNumber ? true : false}
                        helperText={this.props.validationIssues.phoneNumber ? this.props.validationIssues.phoneNumber : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.account && this.props.account.faxNumber ? this.props.account.faxNumber : ""}
                        size="small"
                        label="Fax"
                        variant="standard"
                        fullWidth={true}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => handlePhoneNumberChange(e, "faxNumber")}
                        error={this.props.validationIssues.faxNumber ? true : false}
                        helperText={this.props.validationIssues.faxNumber ? this.props.validationIssues.faxNumber : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.account && this.props.account.email ? this.props.account.email : ""}
                        size="small"
                        label="Email"
                        variant="standard"
                        fullWidth={true}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ email: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ email: e.target.value })}
                        error={this.props.validationIssues.email ? true : false}
                        helperText={this.props.validationIssues.email ? this.props.validationIssues.email : ""}
                    />
                </MUIGrid>
            </MUIGrid>
        );
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "Contact";
    }
}